import { jsx as _jsx } from "react/jsx-runtime";
import { VStack } from "@chakra-ui/react";
import { LanguageSwitcherList } from "./LanguageSwitcherList/index.js";
export const LanguageSwitcher = ({ onItemClick, lists = [], activeItems }) => (_jsx(VStack, { spacing: 10, alignItems: "flex-start", children: lists &&
        lists.map(({ listAutoflow, listHeading, listItems }) => (_jsx(LanguageSwitcherList, { listHeading: listHeading, listItems: listItems, listAutoflow: listAutoflow, onItemClick: onItemClick, activeItems: activeItems }, listHeading))) }));
